module.exports = __webpack_public_path__ + "img/ihrm6.7b60df02.png";